<section class="line-item-modal-container">
    <div class="modal-header">
        <h5 class="modal-title pull-left">
            {{title}}
            <div class="text-small">
                The table shows the list of line items and no of suppliers selected for each line item to negotiate.
            </div>
        </h5>
        <a class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
        </a>
    </div>
    <div class="modal-body">
        <div class="modal-body__content">
            <div class="card-body p-2">
                <div class="d-flex justify-content-between mt-2 mb-4">
                    <p class="mb-0">View Negotiation Summary : </p>
                    <button class="btn btn-primary text-white" [disabled]="!negotiationForm?.valid" (click)="sendNegotiation()">Send for Negotiation</button>
                </div>
                <form>
                    <div class="table-responsive">
                        <table class="table table-striped" [formGroup]="negotiationForm">
                            <thead>
                                <tr>
                                    <th scope="col" [width]="80"></th>
                                    <th scope="col">Selected Supplier</th>
                                    <th scope="col">Line Item #</th>
                                    <th scope="col">Material/Service Code</th>
                                    <th scope="col">Item Desc</th>
                                    <th scope="col">Final Price</th>
                                    <th scope="col">Original Price</th>
                                    <th scope="col">Counter Offer</th>
                                    <th scope="col">packing Val. Type</th>
                                    <th scope="col">Packing charge</th>
                                    <th scope="col">Final Packing charge</th>
                                    <th scope="col">Freight Val. Type</th>
                                    <th scope="col">Freight charge</th>
                                    <th scope="col">Final Freight charge</th>
                                    <th scope="col">Initial Payment Terms</th>
                                    <th scope="col">Final Payment Terms</th>
                                    <th scope="col">Vendor Remarks</th>
                                    <th scope="col">Buyer Remarks</th>
                                    <th scope="col">No of negotiations</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let a of negotiationResultTable | keyvalue; let i = index">
                                    <tr>
                                        <th scope="row" [width]="100">
                                            <a class="cursor-pointer" (click)="toggleAccordion(a.key)">
                                                <span class="fa"
                                                    [ngClass]="{
                                                        'fa-chevron-down' : accordionToggleMap[a.key],
                                                        'fa-chevron-right' : !accordionToggleMap[a.key]
                                                    }">
                                                </span>
                                            </a>
                                        </th>
                                        <th scope="row">
                                            {{ getVendorName(a.key) }}
                                        </th>
                                        <td *ngFor="let x of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17]"></td>
                                    </tr>
                                    <ng-container *ngIf="accordionToggleMap[a.key]">
                                        <ng-container [formArrayName]="a.key">
                                            <ng-container *ngFor="let b of getFormArrayName(a.key); let j = index">
                                                <tr [formGroupName]="j">
                                                    <th scope="row"></th>
                                                    <th scope="row"></th>
                                                    
                                                    <td>
                                                        {{getFormArrayName(a.key).at(j).get('line_item_number').value}}
                                                    </td>
                                                    <td>
                                                        {{getFormArrayName(a.key).at(j).get('material_code').value}}
                                                    </td>
                                                    <td>
                                                        {{getFormArrayName(a.key).at(j).get('item_desc').value}}
                                                    </td>
                                                    <td>
                                                        {{getFormArrayName(a.key).at(j).get('final_price').value || "-"}}
                                                    </td>
                                                    <td>
                                                        {{getFormArrayName(a.key).at(j).get('original_price')?.value || "-"}}
                                                    </td>

                                                    <td>
                                                        <div class="my-1">
                                                            <input type="number" id="buyer_counter_offer" class="form-control w-auto"
                                                            placeholder="Counter Offer" formControlName="buyer_counter_offer"
                                                            [error]="getFormArrayName(a.key).at(j).get('buyer_counter_offer')">
                                                            <form-feedback [formGroup]="getFormArrayName(a.key).at(j)" field="buyer_counter_offer"></form-feedback>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {{getFormArrayName(a.key).at(j).get('packing_percent_or_amount')?.value || "-"}}
                                                    </td>
                                                    <td>
                                                        {{getFormArrayName(a.key).at(j).get('packing_charge')?.value || "-"}}
                                                    </td>
                                                    <td>
                                                        <div class="my-1">
                                                            <input type="number" id="final_packing_charge" class="form-control w-auto"
                                                            placeholder="Final packing charge" formControlName="final_packing_charge"
                                                            >
                                                            <form-feedback [formGroup]="getFormArrayName(a.key).at(j)" field="final_packing_charge"></form-feedback>
                                                            <!-- [error]="getFormArrayName(a.key).at(j).get('final_packing_charge')" -->
                                                        </div>
                                                        <!-- {{getFormArrayName(a.key).at(j).get('final_packing_charge').value || "-"}} -->
                                                    </td>
                                                    <td>
                                                        {{getFormArrayName(a.key).at(j).get('freight_percent_or_amount')?.value || "-"}}
                                                    </td>
                                                    <td>
                                                        {{getFormArrayName(a.key).at(j).get('freight_charge')?.value || "-"}}
                                                    </td>
                                                    <td>
                                                        <div class="my-1">
                                                            <input type="number" id="final_freight_charge" class="form-control w-auto"
                                                            placeholder="Final Freight charge" formControlName="final_freight_charge"
                                                            >
                                                            <form-feedback [formGroup]="getFormArrayName(a.key).at(j)" field="final_freight_charge"></form-feedback>
                                                        </div>
                                                        <!-- [error]="getFormArrayName(a.key).at(j).get('final_freight_charge')" -->
                                                        <!-- {{getFormArrayName(a.key).at(j).get('final_freight_charge').value || "-"}} -->
                                                    </td>
                                                    <td>
                                                        {{getFormArrayName(a.key).at(j).get('original_payment_terms')?.value || "-"}}
                                                    </td>
                                                    <td>
                                                        <div class="my-1">
                                                            <select type="number" id="final_payment_terms" class="form-control w-auto"
                                                            placeholder="Final Payment Terms" formControlName="final_payment_terms" 
                                                            >
                                                            <ng-container *ngFor="let paymentTerm of paymentTermsList;">
                                                                <option [value]="paymentTerm.value">{{paymentTerm.value}}</option>
                                                            </ng-container>
                                                            </select>
                                                            <form-feedback [formGroup]="getFormArrayName(a.key).at(j)" field="final_payment_terms"></form-feedback>
                                                        </div>
                                                        <!-- [error]="getFormArrayName(a.key).at(j).get('final_payment_terms')" -->
                                                        <!-- {{getFormArrayName(a.key).at(j).get('final_payment_terms').value || "-"}} -->
                                                    </td>
                                                    <td>
                                                        {{getFormArrayName(a.key).at(j).get('supplier_remarks').value || "-"}}
                                                    </td>
                                                    
                                                    <td>
                                                        <div class="my-1">
                                                            <input type="text" id="buyer_remarks" class="form-control w-auto"
                                                            placeholder="Remarks" formControlName="buyer_remarks"
                                                            [error]="getFormArrayName(a.key).at(j).get('buyer_remarks')">
                                                            <form-feedback [formGroup]="getFormArrayName(a.key).at(j)" field="buyer_remarks"></form-feedback>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {{getFormArrayName(a.key).at(j).get('negotiation_count').value || 0}}
                                                    </td>
                                                </tr>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div>
            <!-- <button class="btn btn-primary text-white" [disabled]="!negotiationForm?.valid" (click)="sendNegotiation()">Send for Negotiation</button> -->
        </div>
    </div>
</section>